module.exports = __webpack_public_path__ + "3d8caf73a831b1c0299f100c71ccd506.png";